import Form from 'antd/lib/form'
import { WishEditableRow } from '../WishEditableRow/WishEditableRow'

export const WishEditableFormRow = Form.create()(WishEditableRow)
